<template>
  <footer class="footer">
    <section class="footer__top">
      <section class="footer__top__left">
        <a
          href="#"
          class="footer__city-logo"
          aria-label="Botão para a página inicial com a imagem da prefeitura de Sua Cidade"
        >
          <img
            :src="require(`@/assets/theme/${realm}/icons/logo-cidade.svg`)"
            alt="Imagem da prefeitura de Sua Cidade"
          >
        </a>
        <!-- Nesta seção temos os itens de redes sociais. Estes ícones podem mudar de
      acordo com a prefeitura. Podem haver mais ou menos ícones.
      Nao se esqueca de adicionar os dados nos hrefs e nos "aria" tambem.
       -->
        <nav class="footer__social">
          <ul class="footer__social__list">
            <li
              v-if="$t('FOOTER.ICONS.LINKS.facebook') !== 'FOOTER.ICONS.LINKS.facebook'"
              class="footer__social__list__item"
            >
              <a
                :href="$t('FOOTER.ICONS.LINKS.facebook')"
                target="_blank"
                rel="noopener noreferrer"
                class="footer__social__link"
                aria-label="Botão de redirecionamento para o Facebook de Sua Cidade"
              ><svg-wrapper
                class="footer__social__link__icon"
                icon="Facebook"
                title="Ícone da rede social Facebook"
                aria-hidden="true"
              /></a>
            </li>
            <li
              v-if="$t('FOOTER.ICONS.LINKS.instagram') !== 'FOOTER.ICONS.LINKS.instagram'"
              class="footer__social__list__item"
            >
              <a
                :href="$t('FOOTER.ICONS.LINKS.instagram')"
                target="_blank"
                rel="noopener noreferrer"
                class="footer__social__link"
                aria-label="Botão de redirecionamento para o Instagram de Sua Cidade"
              ><svg-wrapper
                class="footer__social__link__icon"
                icon="Instagram"
                title="Ícone da rede social Instagram"
                aria-hidden="true"
              /></a>
            </li>
            <li
              v-if="$t('FOOTER.ICONS.LINKS.youtube') !== 'FOOTER.ICONS.LINKS.youtube'"
              class="footer__social__list__item"
            >
              <a
                :href="$t('FOOTER.ICONS.LINKS.youtube')"
                target="_blank"
                rel="noopener noreferrer"
                class="footer__social__link"
                aria-label="Botão de redirecionamento para o Youtube de Sua Cidade"
              ><svg-wrapper
                class="footer__social__link__icon"
                icon="Youtube"
                title="Ícone do Youtube"
                aria-hidden="true"
              /></a>
            </li>
            <li
              v-if="$t('FOOTER.ICONS.LINKS.city') !== 'FOOTER.ICONS.LINKS.city'"
              class="footer__social__list__item"
            >
              <a
                :href="$t('FOOTER.ICONS.LINKS.city')"
                target="_blank"
                rel="noopener noreferrer"
                class="footer__social__link"
                aria-label="Botão de redirecionamento para o site da prefeitura"
              ><svg-wrapper
                class="footer__social__link__icon"
                icon="Web"
                title="Ícone de um planeta com um cursor indicando a Web de Sua Cidade"
                aria-hidden="true"
              /></a>
            </li>
            <li
              v-if="$t('FOOTER.ICONS.LINKS.linkedin') !== 'FOOTER.ICONS.LINKS.linkedin'"
              class="footer__social__list__item"
            >
              <a
                :href="$t('FOOTER.ICONS.LINKS.linkedin')"
                target="_blank"
                rel="noopener noreferrer"
                class="footer__social__link"
                aria-label="Botão de redirecionamento para o Linkedin de Sua Cidade"
              ><svg-wrapper
                class="footer__social__link__icon"
                icon="Linkedin"
                title="Ícone da rede social Linkedin"
                aria-hidden="true"
              /></a>
            </li>
          </ul>
        </nav>
      </section>
      <!-- Aqui temos os itens de navegação, estes itens são alteráveis e removíveis
      Quando for implementar, não se esqueça de alterar os destinos e as propriedades de "aria"
      para manter um bom padrão de acessibilidade
       -->
      <section class="footer__top__navigation">
        <nav class="footer__top__navigation__column">
          <ul
            role="menu"
            class="footer__top__navigation__column__menu"
          >
            <li role="menuitem">
              <router-link
                :to="{ name: 'FAQ' }"
                class="footer__top__navigation__link"
                :aria-label="`Navegação para a página de ${$t('FOOTER.ABOUT.second')}`"
              >
                {{ $t('FOOTER.ABOUT.second') }}
              </router-link>
            </li>
          </ul>
        </nav>
        <nav class="footer__top__navigation__column">
          <ul
            role="menu"
            class="footer__top__navigation__column__menu"
          >
            <li role="menuitem">
              <router-link
                :to="{ name: 'NewReclamation' }"
                class="footer__top__navigation__link"
              >
                {{ $t('FOOTER.MENU.first') }}
              </router-link>
            </li>
            <li role="menuitem">
              <router-link
                :to="{ name: 'MyComplaints' }"
                class="footer__top__navigation__link"
              >
                {{ $t('FOOTER.MENU.second') }}
              </router-link>
            </li>
          </ul>
        </nav>
      </section>
      <!-- Na secao de contatos tambem temos itens removiveis e que nao vao existir em alguns casos
      Nao se esqueca de adicionar todos os dados nos href`s tambem. -->
      <section class="footer__top__contact">
        <div
          v-if="$t('FOOTER.CONTACT.tel')"
          class="footer__top__contact__info"
        >
          <p class="footer__top__contact__title">
            Telefone 24 horas:
          </p>
          <div class="footer__top__contact__telephones">
            <a
              class="footer__top__contact__telephones__phone"
              aria-label="Telefone para contato da capital"
              href="tel:162"
            >
              <div class="footer__top__contact__telephones__phone__wrapper">
                <google-icon
                  icon-style="filled"
                  class="footer__top__contact__icon"
                  icon="call"
                  aria-hidden="true"
                />
                <p class="footer__top__contact__telephones__phone__number">162</p>
              </div>
              <small class="footer__top__contact__telephones__phone__location">Capital</small>
            </a>
            <!-- Caso haja apenas um (01) telefone, remova tambem o separador. -->
            <span class="footer__top__contact__separator" />
            <div class="footer__top__contact__telephones__multiples">
              <a
                class="footer__top__contact__telephones__phone"
                href="tel:0800.283.9059"
                aria-label="Telefone de contato para demais localidades"
              >
                <div class="footer__top__contact__telephones__phone__wrapper">
                  <google-icon
                    icon-style="filled"
                    class="footer__top__contact__icon"
                    icon="call"
                    aria-hidden="true"
                  />
                  <p class="footer__top__contact__telephones__phone__number">{{ $t('FOOTER.CONTACT.tel') }}</p>
                </div>
                <small
                  class="footer__top__contact__telephones__phone__location"
                >Outras localidades</small>
              </a>
            </div>
          </div>
        </div>
        <div
          v-if="$t('FOOTER.CONTACT.address')"
          class="footer__top__contact__info"
        >
          <p class="footer__top__contact__title">
            Endereço
          </p>
          <div class="footer__top__contact__general">
            <a
              v-if="$t('FOOTER.CONTACT.email')"
              class="footer__top__contact__general__info"
              :href="`mailto:${$t('FOOTER.CONTACT.email')}`"
            >
              <google-icon
                icon-style="filled"
                icon="mail"
                class="footer__top__contact__icon"
                aria-hidden="true"
              /><span
                class="footer__top__contact__general__info__text"
              >{{ $t('FOOTER.CONTACT.email') }}</span>
            </a>
            <!-- No link do maps, apenas copie e cole o endereco no href que o maps funcionara perfeitamente -->
            <a
              v-if="$t('FOOTER.CONTACT.address') && $t('FOOTER.CONTACT.mapsUrl')"
              class="footer__top__contact__general__info"
              :href="$t('FOOTER.CONTACT.mapsUrl')"
              target="__blank"
              rel="noopener noreferrer"
            >
              <google-icon
                icon-style="filled"
                icon="location_on"
                class="footer__top__contact__icon"
                aria-hidden="true"
              /><span
                class="footer__top__contact__general__info__text"
              >{{ $t('FOOTER.CONTACT.address') }}</span>
            </a>
          </div>
        </div>
      </section>
    </section>
    <section class="footer__bottom">
      <a
        href="#"
        class="footer__bottom__link"
        aria-label="Botão redirecionando para o site da UpCities"
      ><svg-wrapper
        class="footer__bottom__link__icon"
        icon="CitiesProduct"
        title="Um produto UpCities"
        aria-hidden="true"
      /></a>
    </section>
  </footer>
</template>

<script>
import SvgWrapper from '@/components/base/svg/SvgWrapper.vue';
import GoogleIcon from './GoogleIcon.vue';

const realmTheme = process.env.VUE_APP_THEME_REALM ?? process.env.VUE_APP_KEYCLOAK_REALM;

export default {
  name: 'FooterLarge',
  components: { SvgWrapper, GoogleIcon },
  data() {
    const realm = realmTheme  === 'Uppersoft'  ?  'upcities' : realmTheme;

    return {
      realm
    };
  }
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: $white;
  margin-bottom: 1rem;

  @include screen(phone-up) {
    margin-bottom: 0;
  }

  @include screen(tablet-up) {
    padding: 0 112px;
  }

  &__top {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 9.75rem;
    gap: 2rem;
    padding: 2rem 0 1.5rem;
    width: 100%;

    @include screen(tablet-big-up) {
      min-height: 5.625rem;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      max-width: 1200px;
    }

    &__left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 2rem;

      @include screen(tablet-big-up) {
        align-items: flex-start;
        gap: 1.5rem;
        max-width: 25%;
      }
    }

    &__navigation {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 1rem;
      width: 100%;

      @include screen(tablet-big-up) {
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        width: calc(100% / 3);
      }

      &__link {
        @include text-m;

        transition: all 200ms ease;

        &:hover {
          color: $primary;
          text-decoration: underline;
        }
      }

      &__column {
        &__menu {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 1rem;

          @include screen(tablet-big-up) {
            align-items: flex-start;
            width: auto;
          }
        }
      }
    }

    &__contact {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 1rem;
      align-items: center;

      @include screen(tablet-big-up) {
        max-width: calc(100% / 4);
        align-items: flex-start;
      }

      &__info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 1rem;
        align-items: center;

        @include screen (tablet-big-up) {
          align-items: start;
        }
      }

      &__icon {
        font-size: 1.125rem;
        color: $primary;
      }

      &__title {
        @include text-m(_, 2);
      }

      &__separator {
        height: 100%;
        width: 1px;
        background: $gray-30;
      }

      &__telephones {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1rem;

        &__phone {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          transition: transform 200ms ease;

          &__wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.375rem;
          }

          &__number {
            @include text-l(_, 2);

            transition: color 200ms ease;
          }

          &:hover &__number {
            color: $primary;
            text-decoration: underline;
          }

          &__location {
            @include text-s;
          }
        }
      }

      &__general {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        max-width: 60%;

        @include screen(tablet-big-up) {
          align-items: flex-start;
          max-width: 100%;
        }

        &__info {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 0.5rem;
          text-align: left;

          @include text-m;

          transition: color 200ms ease;

          &:hover {
            color: $primary;
          }

          &:hover &__text {
            text-decoration: underline;
          }
        }
      }
    }
  }

  &__city-logo {
    max-width: 9.375rem;
  }

  &__social {
    display: flex;
    justify-content: center;
    align-items: center;

    &__list {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 16px;
    }

    &__link {
      width: 2rem;
      height: 2rem;
      background-color: $primary-light;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: background-color ease 300ms;

      &__icon {
        fill: $primary;
        transition: fill ease 300ms;
      }

      &:hover {
        background-color: $primary;
      }

      &:hover &__icon {
        fill: $white;
      }
    }
  }

  &__bottom {
    width: 100%;
    height: 3.5rem;
    background-color: $white;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    max-width: 1200px;

    @include screen(tablet-big-up) {
      max-height: 2.5rem;
    }

    &::before {
      content: "";
      width: 90%;
      height: 0.125rem;
      position: absolute;
      top: 0;
      left: 50%;
      background-color: #d8d8d8;
      transform: translate(-50%, 0);

      @include screen(tablet-big-up) {
        width: 100%;
      }
    }

    &__link {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      &__icon {
        fill: $gray-40;
        transition: fill 200ms ease;
      }

      &:hover &__icon {
        fill: $primary;
      }
    }
  }

  @media print {
    display: none;
  }
}
</style>
